/**
 * Created by chenzheyu on 2017/6/13.
 */

import XkRollBanner from './src/rollBanner.vue'

XkRollBanner.install = function (Vue) {
  Vue.component(XkRollBanner.name, XkRollBanner)
}

export default XkRollBanner



// WEBPACK FOOTER //
// ./src/components/module/rollBanner/index.js